import { useCallback, useRef } from 'react';

/**
 * Hook to control the header z-index when datepicker is opened
 */
const useHeaderZIndex = () => {
  const isAppliedRef = useRef(false);

  /**
   * Lower the header z-index
   */
  const lowerHeaderZIndex = useCallback(() => {
    if (isAppliedRef.current) return;

    try {
      // Add datepicker-open class to the body
      document.body.classList.add('datepicker-open');
      
      // Try different selectors to find the header element
      const headerContainer = document.querySelector('header') || 
                             document.querySelector('header.header') || 
                             document.querySelector('.app-header') || 
                             document.querySelector('body > div > div > div:first-child > div:first-child');
      
      if (headerContainer) {
        // Set z-index to a very low value (-1) to ensure it stays in the background
        headerContainer.setAttribute('style', 'z-index: -1 !important; position: relative !important;');
        isAppliedRef.current = true;
      }
    } catch (error) {
      console.error('Error lowering header z-index:', error);
    }
  }, []);

  /**
   * Reset the header z-index to its default value
   */
  const resetHeaderZIndex = useCallback(() => {
    if (!isAppliedRef.current) return;

    try {
      // Remove datepicker-open class from the body
      document.body.classList.remove('datepicker-open');
      
      const headerContainer = document.querySelector('header') || 
                             document.querySelector('header.header') || 
                             document.querySelector('.app-header') || 
                             document.querySelector('body > div > div > div:first-child > div:first-child');
      
      if (headerContainer) {
        headerContainer.removeAttribute('style');
        isAppliedRef.current = false;
      }
    } catch (error) {
      console.error('Error resetting header z-index:', error);
    }
  }, []);

  return { lowerHeaderZIndex, resetHeaderZIndex };
};

export default useHeaderZIndex; 